// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"label-component_uk-open__kyRkD","grecaptcha-badge":"label-component_grecaptcha-badge__Vn5H8","label":"label-component_label__S29pL","label__left-pointy":"label-component_label__left-pointy__VlaBS","label__right-pointy":"label-component_label__right-pointy__lOkyc"};
    if(module.hot) {
      // 1793877031221
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  